import { getUnreadNotifyMessageCount } from "@/api/exam/notifyMessage";

const notify = {
  state: {
    // 未读站内信数量（用于顶部消息角标）
    unreadNotifyCount: 0,
  },

  mutations: {
    SET_UNREAD_NOTIFY_COUNT(state, payload) {
      state.unreadNotifyCount = payload || 0;
    },
  },

  actions: {
    // 刷新未读站内信数量；未登录或接口异常时不影响主流程
    fetchUnreadNotifyCount({ commit }) {
      return getUnreadNotifyMessageCount()
        .then((count) => {
          commit("SET_UNREAD_NOTIFY_COUNT", count);
          return count;
        })
        .catch(() => {
          return 0;
        });
    },
  },
};

export default notify;
